import React from 'react';
import { CartItem as CartItemType } from '../types';
import { useCart } from '../context/CartContext';
import './CartItem.css';

interface CartItemProps {
  item: CartItemType;
}

const CartItem: React.FC<CartItemProps> = ({ item }) => {
  const { updateQuantity, removeFromCart } = useCart();
  const { product, quantity } = item;

  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (value > 0) {
      // Get product ID (either _id or id)
      const productId = product._id || (product as any).id?.toString();
      if (productId) {
        updateQuantity(productId, value);
      }
    }
  };

  const handleRemove = () => {
    // Get product ID (either _id or id)
    const productId = product._id || (product as any).id?.toString();
    if (productId) {
      removeFromCart(productId);
    }
  };

  return (
    <div className="cart-item">
      <div className="cart-item-details">
        {product.imageUrl && (
          <div className="cart-item-image">
            <img src={product.imageUrl} alt={product.name} />
          </div>
        )}
        
        <div className="cart-item-info">
          <h4 className="cart-item-name">{product.name}</h4>
          <p className="cart-item-price">{product.price.toLocaleString('hu-HU')} Ft</p>
        </div>
      </div>
      
      <div className="cart-item-actions">
        <div className="quantity-control">
          <button 
            className="quantity-btn"
            onClick={() => {
              const productId = product._id || (product as any).id?.toString();
              if (productId) {
                updateQuantity(productId, quantity - 1);
              }
            }}
            disabled={quantity <= 1}
          >
            -
          </button>
          <input
            type="number"
            min="1"
            value={quantity}
            onChange={handleQuantityChange}
            className="quantity-input"
          />
          <button 
            className="quantity-btn"
            onClick={() => {
              const productId = product._id || (product as any).id?.toString();
              if (productId) {
                updateQuantity(productId, quantity + 1);
              }
            }}
          >
            +
          </button>
        </div>
        
        <div className="cart-item-subtotal">
          {(product.price * quantity).toLocaleString('hu-HU')} Ft
        </div>
        
        <button 
          className="remove-btn"
          onClick={handleRemove}
          aria-label="Eltávolítás a kosárból"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default CartItem;
